import Image from 'next/image';
import React from 'react';
import SVG from 'react-inlinesvg';

import Button from '../Button';
import Section from '../Section';

const CaseStudyCard = ({
  quote = "PopSQL's collaboration features have been game-changing and have really helped our non-technical users get comfortable with SQL and answer their own questions.",
  author = 'Mark Scoptur',
  authorTitle = 'VP Product, FactoryFix',
  ctaText = 'Read more customer stories',
  customerName = 'FactoryFix',
  aboutCustomer = 'saved 4 hours per analyst per week using PopSQL',
  customerIcon = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/factoryfix-test-icon.svg`,
  customerBg = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/test-casestudy.png`,
}: {
  aboutCustomer?: string;
  author?: string;
  authorTitle?: string;
  ctaText?: string;
  customerBg?: string;
  customerIcon?: string;
  customerName?: string;
  quote?: string;
}) => {
  return (
    <Section>
      <div className="py-8 px-7 lg:pl-16 lg:pr-7 gap-12 flex flex-col lg:flex-row justify-center shadow-features items-start mx-auto border-[0.5px] rounded-[24px] overflow-hidden">
        <figure className="font-inter font-medium flex flex-col items-start justify-between gap-8 h-full">
          <div className="flex flex-col gap-8">
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:pt-6 tracking-tight">
              "{`${quote}`}"
            </blockquote>

            <figcaption className="flex flex-col font-semibold text-sm sm:text-base">
              {author}
              <cite className="not-italic font-medium text-gray-600">
                {authorTitle}
              </cite>
            </figcaption>
          </div>

          <Button
            href="/customers"
            variant="ghost"
            hasArrow
            className="lg:-ml-6 lg:mt-28 mx-auto"
          >
            {ctaText}
          </Button>
        </figure>

        <figure className="h-[360px] lg:h-[500px] w-full lg:w-[400px] shrink-0 relative font-inter relative">
          <figcaption className="absolute top-0 left-0 font-medium p-6 lg:p-8 text-sm sm:text-base text-white">
            <cite className="not-italic font-semibold">{customerName}</cite>{' '}
            {aboutCustomer}
          </figcaption>
          <Image
            src={customerBg}
            alt={`${customerName} Case study`}
            className="object-cover w-full h-full rounded-[16px]"
            layout="fill"
          />
          <div className="border-[0.5px] shadow-lg border-black/10 bg-white h-24 w-24 lg:h-40 lg:w-40 flex bottom-6 lg:bottom-12 left-6 lg:-left-8 absolute rounded-[12px] lg:rounded-[16px] lg:rounded-[24px] flex items-center justify-center">
            <SVG className="h-16 w-16 lg:h-24 lg:w-24" src={customerIcon} />
          </div>
        </figure>
      </div>
    </Section>
  );
};

export default CaseStudyCard;
